const consentManagerTriggerLinks = document.querySelectorAll('[href="#consent-manager"]');

consentManagerTriggerLinks.forEach(link => {
    link.addEventListener('click', e => {
        e.preventDefault();

        if (typeof Cookiebot !== 'undefined') {
            Cookiebot.show();
        }
    });
});
